import { useAtom } from "jotai";
import { backendDataAtom } from "atoms/backendDataAtom.js";
import { backendPost, backendDelete } from "@accredo/fe-shared/services/dataService.js";
import { useSnackbar } from "notistack";
import { updateListItemState } from "./listStateHelpers.js";

export function useIncomingMailActions(onCountsChange) {
  const [backendData, setBackendData] = useAtom(backendDataAtom);
  const { enqueueSnackbar } = useSnackbar();

  const state =
    backendData?.type === "incoming-mail-list"
      ? backendData
      : { data: [], meta: {} };

  const setState = (data) => {
    setBackendData({
      type: "incoming-mail-list",
      data: data,
    });
  };

  const assignClaim = async (mail_id, schaden_id) => {
    return await backendPost("data/incoming-mails/assign-schaden", {
      label: "E-Mail Schaden zuordnen",
      toSend: {
        incoming_mail_id: mail_id,
        schaden_id: schaden_id,
      },
      enqueueSnackbar,
      setResult: (res) => {
        const updatedMail = res?.data || res;
        updateListItemState(backendData, setBackendData, updatedMail);
        if (onCountsChange) {
          onCountsChange();
        }
      },
    });
  };

  const trashMail = async (mail_id) => {
    return await backendDelete(`data/incoming-mails/${mail_id}`, {
      label: "E-Mail in den Papierkorb verschieben",
      enqueueSnackbar,
      setResult: () => {
        // Remove from list
        const items = backendData?.data?.data || [];
        const updatedBackendData = {
          ...backendData,
          data: {
            ...backendData?.data,
            data: items.filter((item) => item.id !== mail_id),
          },
        };
        setBackendData(updatedBackendData);
        if (onCountsChange) {
          onCountsChange();
        }
      },
    });
  };

  const restoreMail = async (mail_id) => {
    return await backendPost(`data/incoming-mails/${mail_id}/restore`, {
      label: "E-Mail wiederherstellen",
      enqueueSnackbar,
      setResult: (res) => {
        // Remove from trash list
        const items = backendData?.data?.data || [];
        const updatedBackendData = {
          ...backendData,
          data: {
            ...backendData?.data,
            data: items.filter((item) => item.id !== mail_id),
          },
        };
        setBackendData(updatedBackendData);
        if (onCountsChange) {
          onCountsChange();
        }
      },
    });
  };

  return {
    assignClaim,
    trashMail,
    restoreMail,
    setState,
    state,
  };
}
